(ns journal-app-client.notification
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [journal-app-client.service-worker :as sw]))

(defonce permission (r/atom nil))
(defonce active-notification (r/atom nil))

(defn persistent? []
  (and @permission @sw/registration))

(defn request-permission []
  (when (js-in "Notification" js/window)
    (try
      (-> (. js/window.Notification (requestPermission))
          (.then
           (fn [result]
             (reset! permission (not (or (= result "denied") (= result "default"))))
             (js/console.log "Promise Permission asked"))))

      (catch js/Object err
        (js/console.error "Failed promise" err)
        (. js/window.Notification
           (requestPermission
            (fn [result]
              (reset! permission (not (or (= result "denied") (= result "default"))))
              (js/console.log "Callback Permission asked"))))))))

(defn persistent [title options]
  (let [js-options (clj->js
                    {:body "Body text"
                     :icon "favicon/android-chrome-192x192.png"
                     :badge "https://karmoybilsenter.no/wp-content/uploads/2016/04/sign-check-icon-460x460.png"
                     :image "favicon/android-chrome-512x512.png"
                     :vibrate [100 50 100]
                     :text true
                     :placeholder "hello"
                     #_:silent #_true                      ;; Only silent or vibrate can be active. Choose one or the other
                     :tag (str "notification-id-" (.getTime (new js/Date)))
                     :actions [{:action "explore"
                                :type "text"               ;; This can be button or text input
                                :placeholder "Hello"       ;; For text input
                                :title "Explore this new world"
                                :icon "favicon/mstile-150x150.png"}
                               {:action "close"
                                :type "button"
                                :title "Close notification"
                                :icon "favicon/mstile-310x310.png"}]
                     :requireInteraction false  ;;Will stay active for at least 20 seconds or until clicked on
                     :data {:options {:urlToOpen nil #_"https://www.google.com/"
                                      :page "/home/"
                                      :notificationCloseEvent true
                                      :action "message"}}})]
    (.showNotification @sw/registration title js-options)))

(defn non-persistent [title options]
  (let [js-options (clj->js
                    {:body "Body text"
                     :icon "favicon/android-chrome-192x192.png"
                     :badge "https://karmoybilsenter.no/wp-content/uploads/2016/04/sign-check-icon-460x460.png"
                     :image "favicon/android-chrome-512x512.png"
                     :vibrate [100 50 100]
                     :tag "notification-id"})
        notification (new js/window.Notification title js-options)]
    ;;THis callback will be called even if the user has denied chrome to do native notification
    (set! (.-onshow notification)
          (if (fn? (:on-show options))
            (:on-show options)
            (fn []
              (js/console.log "Notification showed"))))
    ;; This callback will be called if the user clicks the notification
    (set! (.-onclick notification)
          (if (fn? (:on-click options))
            (:on-click options)
            (fn []
              (js/console.log "Notification clicked"))))
    ;;This callback will be called when the close() function of the notification is called
    (set! (.-onclose notification)
          (if (fn? (:on-close options))
            (:on-close options)
            (fn []
              (js/console.log "Notification closed"))))
    (set! (.-onerror notification)
          (if (fn? (:on-error options))
            (:on-error options)
            (fn []
              (js/console.log "Notification error"))))

    (reset! active-notification notification)))

(defn create [& [options]]
  (let [title (or (:title options) "Default title")]
    (if (persistent?)
      (persistent title (clj->js (select-keys options [:body :icon :badge :image :tag :vibrate])))
      (non-persistent title (clj->js (dissoc options :title :on-show :on-click :on-close :on-error))))))

(defn close []
  (when @active-notification
    (.close @active-notification)
    (reset! active-notification nil)))
